export default "__VITE_ASSET__CNAVjZJs__"